module.exports = __webpack_public_path__ + "img/game_gegame.da9dac1.jpg";